import { StyleSheet as q } from "../../sheet/dist/emotion-sheet.browser.esm.js";
import { stringify as L, serialize as $ } from "../../../stylis/src/Serializer.js";
import { COMMENT as K, RULESET as U, KEYFRAMES as F, DECLARATION as Y, WEBKIT as s, MS as f, MOZ as E } from "../../../stylis/src/Enum.js";
import { rulesheet as B, middleware as H } from "../../../stylis/src/Middleware.js";
import { combine as Z, replace as i, hash as z, charat as b, strlen as A, indexof as R, match as G, from as J } from "../../../stylis/src/Utility.js";
import { copy as m, dealloc as Q, alloc as X, next as C, token as I, peek as k, delimit as j, slice as v, position as O } from "../../../stylis/src/Tokenizer.js";
import { compile as rr } from "../../../stylis/src/Parser.js";
var er = function(e, t, n) {
  for (var c = 0, a = 0; c = a, a = k(), c === 38 && a === 12 && (t[n] = 1), !I(a); )
    C();
  return v(e, O);
}, tr = function(e, t) {
  var n = -1, c = 44;
  do
    switch (I(c)) {
      case 0:
        c === 38 && k() === 12 && (t[n] = 1), e[n] += er(O - 1, t, n);
        break;
      case 2:
        e[n] += j(c);
        break;
      case 4:
        if (c === 44) {
          e[++n] = k() === 58 ? "&\f" : "", t[n] = e[n].length;
          break;
        }
      default:
        e[n] += J(c);
    }
  while (c = C());
  return e;
}, sr = function(e, t) {
  return Q(tr(X(e), t));
}, P = /* @__PURE__ */ new WeakMap(), nr = function(e) {
  if (!(e.type !== "rule" || !e.parent || e.length < 1)) {
    for (var t = e.value, n = e.parent, c = e.column === n.column && e.line === n.line; n.type !== "rule"; )
      if (n = n.parent, !n)
        return;
    if (!(e.props.length === 1 && t.charCodeAt(0) !== 58 && !P.get(n)) && !c) {
      P.set(e, !0);
      for (var a = [], l = sr(t, a), h = n.props, u = 0, d = 0; u < l.length; u++)
        for (var p = 0; p < h.length; p++, d++)
          e.props[d] = a[u] ? l[u].replace(/&\f/g, h[p]) : h[p] + " " + l[u];
    }
  }
}, ir = function(e) {
  if (e.type === "decl") {
    var t = e.value;
    t.charCodeAt(0) === 108 && t.charCodeAt(2) === 98 && (e.return = "", e.value = "");
  }
}, cr = "emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason", ar = function(e) {
  return e.type === "comm" && e.children.indexOf(cr) > -1;
}, or = function(e) {
  return function(t, n, c) {
    if (!(t.type !== "rule" || e.compat)) {
      var a = t.value.match(/(:first|:nth|:nth-last)-child/g);
      if (a) {
        for (var l = t.parent === c[0], h = l ? c[0].children : c, u = h.length - 1; u >= 0; u--) {
          var d = h[u];
          if (d.line < t.line)
            break;
          if (d.column < t.column) {
            if (ar(d))
              return;
            break;
          }
        }
        a.forEach(function(p) {
          console.error('The pseudo class "' + p + '" is potentially unsafe when doing server-side rendering. Try changing it to "' + p.split("-child")[0] + '-of-type".');
        });
      }
    }
  };
}, T = function(e) {
  return e.type.charCodeAt(1) === 105 && e.type.charCodeAt(0) === 64;
}, fr = function(e, t) {
  for (var n = e - 1; n >= 0; n--)
    if (!T(t[n]))
      return !0;
  return !1;
}, N = function(e) {
  e.type = "", e.value = "", e.return = "", e.children = "", e.props = "";
}, pr = function(e, t, n) {
  !T(e) || (e.parent ? (console.error("`@import` rules can't be nested inside other rules. Please move it to the top level and put it before regular rules. Keep in mind that they can only be used within global styles."), N(e)) : fr(t, n) && (console.error("`@import` rules can't be after other rules. Please put your `@import` rules before your other rules."), N(e)));
};
function D(r, e) {
  switch (z(r, e)) {
    case 5103:
      return s + "print-" + r + r;
    case 5737:
    case 4201:
    case 3177:
    case 3433:
    case 1641:
    case 4457:
    case 2921:
    case 5572:
    case 6356:
    case 5844:
    case 3191:
    case 6645:
    case 3005:
    case 6391:
    case 5879:
    case 5623:
    case 6135:
    case 4599:
    case 4855:
    case 4215:
    case 6389:
    case 5109:
    case 5365:
    case 5621:
    case 3829:
      return s + r + r;
    case 5349:
    case 4246:
    case 4810:
    case 6968:
    case 2756:
      return s + r + E + r + f + r + r;
    case 6828:
    case 4268:
      return s + r + f + r + r;
    case 6165:
      return s + r + f + "flex-" + r + r;
    case 5187:
      return s + r + i(r, /(\w+).+(:[^]+)/, s + "box-$1$2" + f + "flex-$1$2") + r;
    case 5443:
      return s + r + f + "flex-item-" + i(r, /flex-|-self/, "") + r;
    case 4675:
      return s + r + f + "flex-line-pack" + i(r, /align-content|flex-|-self/, "") + r;
    case 5548:
      return s + r + f + i(r, "shrink", "negative") + r;
    case 5292:
      return s + r + f + i(r, "basis", "preferred-size") + r;
    case 6060:
      return s + "box-" + i(r, "-grow", "") + s + r + f + i(r, "grow", "positive") + r;
    case 4554:
      return s + i(r, /([^-])(transform)/g, "$1" + s + "$2") + r;
    case 6187:
      return i(i(i(r, /(zoom-|grab)/, s + "$1"), /(image-set)/, s + "$1"), r, "") + r;
    case 5495:
    case 3959:
      return i(r, /(image-set\([^]*)/, s + "$1$`$1");
    case 4968:
      return i(i(r, /(.+:)(flex-)?(.*)/, s + "box-pack:$3" + f + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + s + r + r;
    case 4095:
    case 3583:
    case 4068:
    case 2532:
      return i(r, /(.+)-inline(.+)/, s + "$1$2") + r;
    case 8116:
    case 7059:
    case 5753:
    case 5535:
    case 5445:
    case 5701:
    case 4933:
    case 4677:
    case 5533:
    case 5789:
    case 5021:
    case 4765:
      if (A(r) - 1 - e > 6)
        switch (b(r, e + 1)) {
          case 109:
            if (b(r, e + 4) !== 45)
              break;
          case 102:
            return i(r, /(.+:)(.+)-([^]+)/, "$1" + s + "$2-$3$1" + E + (b(r, e + 3) == 108 ? "$3" : "$2-$3")) + r;
          case 115:
            return ~R(r, "stretch") ? D(i(r, "stretch", "fill-available"), e) + r : r;
        }
      break;
    case 4949:
      if (b(r, e + 1) !== 115)
        break;
    case 6444:
      switch (b(r, A(r) - 3 - (~R(r, "!important") && 10))) {
        case 107:
          return i(r, ":", ":" + s) + r;
        case 101:
          return i(r, /(.+:)([^;!]+)(;|!.+)?/, "$1" + s + (b(r, 14) === 45 ? "inline-" : "") + "box$3$1" + s + "$2$3$1" + f + "$2box$3") + r;
      }
      break;
    case 5936:
      switch (b(r, e + 11)) {
        case 114:
          return s + r + f + i(r, /[svh]\w+-[tblr]{2}/, "tb") + r;
        case 108:
          return s + r + f + i(r, /[svh]\w+-[tblr]{2}/, "tb-rl") + r;
        case 45:
          return s + r + f + i(r, /[svh]\w+-[tblr]{2}/, "lr") + r;
      }
      return s + r + f + r + r;
  }
  return r;
}
var ur = function(e, t, n, c) {
  if (e.length > -1 && !e.return)
    switch (e.type) {
      case Y:
        e.return = D(e.value, e.length);
        break;
      case F:
        return $([m(e, {
          value: i(e.value, "@", "@" + s)
        })], c);
      case U:
        if (e.length)
          return Z(e.props, function(a) {
            switch (G(a, /(::plac\w+|:read-\w+)/)) {
              case ":read-only":
              case ":read-write":
                return $([m(e, {
                  props: [i(a, /:(read-\w+)/, ":" + E + "$1")]
                })], c);
              case "::placeholder":
                return $([m(e, {
                  props: [i(a, /:(plac\w+)/, ":" + s + "input-$1")]
                }), m(e, {
                  props: [i(a, /:(plac\w+)/, ":" + E + "$1")]
                }), m(e, {
                  props: [i(a, /:(plac\w+)/, f + "input-$1")]
                })], c);
            }
            return "";
          });
    }
}, hr = [ur], Er = function(e) {
  var t = e.key;
  if (process.env.NODE_ENV !== "production" && !t)
    throw new Error(`You have to configure \`key\` for your cache. Please make sure it's unique (and not equal to 'css') as it's used for linking styles to your cache.
If multiple caches share the same key they might "fight" for each other's style elements.`);
  if (t === "css") {
    var n = document.querySelectorAll("style[data-emotion]:not([data-s])");
    Array.prototype.forEach.call(n, function(o) {
      var y = o.getAttribute("data-emotion");
      y.indexOf(" ") !== -1 && (document.head.appendChild(o), o.setAttribute("data-s", ""));
    });
  }
  var c = e.stylisPlugins || hr;
  if (process.env.NODE_ENV !== "production" && /[^a-z-]/.test(t))
    throw new Error('Emotion key must only contain lower case alphabetical characters and - but "' + t + '" was passed');
  var a = {}, l, h = [];
  l = e.container || document.head, Array.prototype.forEach.call(
    document.querySelectorAll('style[data-emotion^="' + t + ' "]'),
    function(o) {
      for (var y = o.getAttribute("data-emotion").split(" "), g = 1; g < y.length; g++)
        a[y[g]] = !0;
      h.push(o);
    }
  );
  var u, d = [nr, ir];
  process.env.NODE_ENV !== "production" && d.push(or({
    get compat() {
      return w.compat;
    }
  }), pr);
  {
    var p, M = [L, process.env.NODE_ENV !== "production" ? function(o) {
      o.root || (o.return ? p.insert(o.return) : o.value && o.type !== K && p.insert(o.value + "{}"));
    } : B(function(o) {
      p.insert(o);
    })], S = H(d.concat(c, M)), W = function(y) {
      return $(rr(y), S);
    };
    u = function(y, g, x, _) {
      p = x, process.env.NODE_ENV !== "production" && g.map !== void 0 && (p = {
        insert: function(V) {
          x.insert(V + g.map);
        }
      }), W(y ? y + "{" + g.styles + "}" : g.styles), _ && (w.inserted[g.name] = !0);
    };
  }
  var w = {
    key: t,
    sheet: new q({
      key: t,
      container: l,
      nonce: e.nonce,
      speedy: e.speedy,
      prepend: e.prepend,
      insertionPoint: e.insertionPoint
    }),
    nonce: e.nonce,
    inserted: a,
    registered: {},
    insert: u
  };
  return w.sheet.hydrate(h), w;
};
export {
  Er as default
};
//# sourceMappingURL=emotion-cache.browser.esm.js.map
